/* ═══════════════════════════════════════════════════════
   NINARA THEME — Main JavaScript
   GSAP + ScrollTrigger + CSS sticky for scroll sections
   ═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {
  initWishlist();
  initRecentlyViewed();
  initCartAjax();
  initHeader();
  initNewsletterForm();
  initEnquiryForms();
  initVideoLightbox();

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);
  initHero();
  initCurtainReveals();
  init3DCards();
  initOriginalsSpotlight();
  initCraftRegions();
  initFadeIns();
  initWatchAndBuy();
  initFounderLetter();

  /* ── Animated Text (word-by-word reveal) ── */
  document.querySelectorAll('.n-anim-text').forEach(function(el) {
    var words = el.querySelectorAll('.n-word');
    ScrollTrigger.create({
      trigger: el, start: 'top 88%', once: true,
      onEnter: function() {
        el.classList.add('is-visible');
        words.forEach(function(w, i) { w.style.transitionDelay = (i * 0.08) + 's'; });
      }
    });
  });
});

/* ══════════════════════════════════════════
   HEADER
   ══════════════════════════════════════════ */
function initHeader() {
  var header = document.querySelector('.n-header');
  var announce = document.querySelector('.n-announce');
  var nav = document.querySelector('.n-nav');
  var logo = document.querySelector('.n-nav__logo');
  var megaMenus = document.querySelectorAll('.n-mega');
  var megaTriggers = document.querySelectorAll('[data-mega-trigger]');
  var searchOverlay = document.querySelector('.n-search');
  var cartOverlay = document.querySelector('.n-cart-overlay');
  var cartDrawer = document.querySelector('.n-cart-drawer');
  var mobileMenu = document.querySelector('.n-mobile-menu');
  if (!header) return;

  var isHome = document.body.classList.contains('template-index');
  var lastScroll = 0, isScrolled = false, activeMega = null, megaTimeout;

  /* Announcement rotation */
  var announceTexts = announce ? announce.querySelectorAll('.n-announce__text') : [];
  var announceIdx = 0;
  if (announceTexts.length > 1) {
    announceTexts[0].classList.add('is-active');
    setInterval(function() {
      announceTexts[announceIdx].classList.remove('is-active');
      announceTexts[announceIdx].classList.add('is-exit');
      setTimeout(function() { announceTexts.forEach(function(t) { t.classList.remove('is-exit'); }); }, 500);
      announceIdx = (announceIdx + 1) % announceTexts.length;
      announceTexts[announceIdx].classList.add('is-active');
    }, 4000);
  } else if (announceTexts.length === 1) { announceTexts[0].classList.add('is-active'); }

  function updateNavStyle() {
    var transparent = isHome && !isScrolled && !activeMega && window.innerWidth >= 1024;
    if (announce) { announce.classList.toggle('n-announce--transparent', transparent); announce.classList.toggle('n-announce--solid', !transparent); }
    if (nav) { nav.classList.toggle('n-nav--transparent', transparent); nav.classList.toggle('n-nav--solid', !transparent); }
    if (logo) { logo.classList.toggle('n-nav__logo--invert', transparent); }
  }

  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        var y = window.scrollY;
        isScrolled = y > 50;
        updateNavStyle();
        if (y > 150 && y > lastScroll) header.classList.add('is-hidden');
        else header.classList.remove('is-hidden');
        lastScroll = y;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  updateNavStyle();

  function openMega(id) { clearTimeout(megaTimeout); if (activeMega === id) return; closeMega(); activeMega = id; var m = document.getElementById(id); if (m) m.classList.add('is-active'); updateNavStyle(); }
  function closeMega() { if (!activeMega) return; var m = document.getElementById(activeMega); if (m) m.classList.remove('is-active'); activeMega = null; updateNavStyle(); }
  megaTriggers.forEach(function(t) { t.addEventListener('mouseenter', function() { openMega(t.dataset.megaTrigger); }); t.addEventListener('mouseleave', function() { megaTimeout = setTimeout(closeMega, 100); }); });
  megaMenus.forEach(function(m) { m.addEventListener('mouseenter', function() { clearTimeout(megaTimeout); }); m.addEventListener('mouseleave', function() { megaTimeout = setTimeout(closeMega, 80); }); });
  header.addEventListener('mouseleave', closeMega);

  document.querySelectorAll('.n-mega__link[data-preview]').forEach(function(link) {
    link.addEventListener('mouseenter', function() {
      var mega = link.closest('.n-mega');
      if (!mega) return;
      mega.querySelectorAll('.n-mega__preview img').forEach(function(img) { img.classList.remove('is-active'); });
      var target = mega.querySelector('.n-mega__preview img[data-id="' + link.dataset.preview + '"]');
      if (target) target.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-open-search]').forEach(function(btn) { btn.addEventListener('click', function() { if (searchOverlay) { searchOverlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; } var inp = searchOverlay ? searchOverlay.querySelector('.n-search__input') : null; if (inp) setTimeout(function() { inp.focus(); }, 300); }); });
  document.querySelectorAll('[data-close-search]').forEach(function(btn) { btn.addEventListener('click', function() { if (searchOverlay) { searchOverlay.classList.remove('is-open'); document.body.style.overflow = ''; } }); });

  function openCartAndFetch() {
    if (cartOverlay) cartOverlay.classList.add('is-open');
    if (cartDrawer) cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (window.nRenderCart) fetch('/cart.js').then(function(r) { return r.json(); }).then(window.nRenderCart).catch(function() {});
  }
  document.querySelectorAll('[data-open-cart]').forEach(function(btn) { btn.addEventListener('click', openCartAndFetch); });
  function closeCart() { if (cartOverlay) cartOverlay.classList.remove('is-open'); if (cartDrawer) cartDrawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  document.querySelectorAll('[data-close-cart]').forEach(function(btn) { btn.addEventListener('click', closeCart); });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.querySelectorAll('[data-open-mobile-menu]').forEach(function(btn) { btn.addEventListener('click', function() { if (mobileMenu) { mobileMenu.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }); });
  document.querySelectorAll('[data-close-mobile-menu]').forEach(function(btn) { btn.addEventListener('click', function() { if (mobileMenu) { mobileMenu.classList.remove('is-open'); document.body.style.overflow = ''; } }); });

  window.addEventListener('open-mobile-nav', function(e) {
    if (e.detail === 'search' && searchOverlay) { searchOverlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; var inp = searchOverlay.querySelector('.n-search__input'); if (inp) setTimeout(function() { inp.focus(); }, 300); }
    else if (e.detail === 'cart') { openCartAndFetch(); }
  });
}

/* ══════════════════════════════════════════
   HERO — Multi-slide slideshow with crossfade
   Auto-rotate 5s, pause on hover, terracotta dots
   ══════════════════════════════════════════ */
function initHero() {
  var hero = document.querySelector('.n-hero');
  if (!hero) return;

  var bgSlides = hero.querySelectorAll('.n-hero__slide');
  var contentSlides = hero.querySelectorAll('.n-hero__content-slide');
  var dots = hero.querySelectorAll('.n-hero__dot');
  var count = bgSlides.length;
  var current = 0;
  var interval = parseInt(hero.dataset.interval || '5000', 10);
  var timer = null;
  var paused = false;

  /* Animate first slide text */
  var firstContent = hero.querySelector('.n-hero__content-slide.is-active');
  if (firstContent) {
    firstContent.querySelectorAll('.n-word').forEach(function(w, i) {
      gsap.fromTo(w, { opacity: 0, y: 20, filter: 'blur(10px)' }, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.5, delay: 0.3 + i * 0.08, ease: 'power3.out' });
    });
  }

  function goTo(idx) {
    if (idx === current || idx < 0 || idx >= count) return;
    var prev = current;
    /* Fade out current content first, bg simultaneously */
    contentSlides[prev].classList.remove('is-active');
    bgSlides[prev].classList.remove('is-active');
    if (dots.length) dots[prev].classList.remove('is-active');
    current = idx;
    /* Background fades in immediately; content follows with short delay */
    bgSlides[current].classList.add('is-active');
    if (dots.length) dots[current].classList.add('is-active');
    /* Wait for prev content to fully fade out (CSS = 0.5s) before fading in next, eliminates dual-visible flicker */
    setTimeout(function() {
      contentSlides[current].classList.add('is-active');
    }, 500);
  }

  function next() { goTo((current + 1) % count); }

  function startAuto() {
    if (count <= 1) return;
    stopAuto();
    timer = setInterval(function() { if (!paused) next(); }, interval);
  }

  function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }

  /* Dot clicks */
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      goTo(parseInt(dot.dataset.dot, 10));
      startAuto(); /* reset timer after manual nav */
    });
  });

  /* Pause on hover */
  if (count > 1) {
    hero.addEventListener('mouseenter', function() { paused = true; });
    hero.addEventListener('mouseleave', function() { paused = false; });
  }

  /* Touch swipe to navigate — horizontal-only so vertical scroll still works */
  var touchStartX = 0, touchStartY = 0;
  hero.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  hero.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      goTo(dx < 0 ? (current + 1) % count : (current - 1 + count) % count);
      startAuto();
    }
  }, { passive: true });

  /* Start auto-rotation */
  startAuto();

  /* Parallax on scroll */
  var bg = hero.querySelector('.n-hero__bg');
  if (bg && typeof ScrollTrigger !== 'undefined') {
    gsap.to(bg, {
      yPercent: 20,
      ease: 'none',
      scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
    });
  }
}

/* ══════════════════════════════════════════
   CURTAIN DROP REVEALS
   ══════════════════════════════════════════ */
function initCurtainReveals() {
  document.querySelectorAll('[data-curtain]').forEach(function(curtain) {
    var delay = parseFloat(curtain.dataset.curtainDelay || '0');
    var imgWrap = curtain.nextElementSibling;
    ScrollTrigger.create({
      trigger: curtain.parentElement, start: 'top 80%', once: true,
      onEnter: function() {
        gsap.to(curtain, { yPercent: 100, duration: 0.8, delay: delay, ease: 'power3.inOut' });
        if (imgWrap) gsap.fromTo(imgWrap, { scale: 1.2 }, { scale: 1, duration: 1.2, delay: delay, ease: 'power2.out' });
      }
    });
  });
}

/* ══════════════════════════════════════════
   3D PERSPECTIVE CARDS
   ══════════════════════════════════════════ */
function init3DCards() {
  document.querySelectorAll('[data-3d-card]').forEach(function(card) {
    var delay = parseFloat(card.dataset['3dDelay'] || '0');
    gsap.from(card, {
      opacity: 0, y: 80, rotateX: 15, scale: 0.92,
      duration: 0.7, delay: delay, ease: 'power3.out',
      scrollTrigger: { trigger: card, start: 'top 88%', once: true }
    });
  });
}

/* ══════════════════════════════════════════
   ORIGINALS SPOTLIGHT — CSS sticky + scrubbed clip-path reveals
   Section height: 300vh → sticky inner = 100vh → 200vh of scroll distance
   Layer 2: 5%-30% of 300vh = 15vh-90vh scroll (75vh range)
   Layer 3: 35%-60% of 300vh = 105vh-180vh scroll (75vh range, fits within 200vh)
   ══════════════════════════════════════════ */
function initOriginalsSpotlight() {
  var section = document.querySelector('.n-originals');
  if (!section) return;

  var layer2 = section.querySelector('[data-layer="2"]');
  var layer3 = section.querySelector('[data-layer="3"]');
  var imgContainer = section.querySelector('.n-originals__images');

  if (layer2) {
    gsap.fromTo(layer2,
      { clipPath: 'inset(100% 0 0 0)' },
      { clipPath: 'inset(0% 0 0 0)', ease: 'power2.inOut',
        scrollTrigger: { trigger: section, start: '10% top', end: '30% top', scrub: 1 }
      }
    );
  }

  if (layer3) {
    gsap.fromTo(layer3,
      { clipPath: 'inset(100% 0 0 0)' },
      { clipPath: 'inset(0% 0 0 0)', ease: 'power2.inOut',
        scrollTrigger: { trigger: section, start: '38% top', end: '58% top', scrub: 1 }
      }
    );
  }

  if (imgContainer) {
    gsap.fromTo(imgContainer, { scale: 1 }, {
      scale: 1.08, ease: 'none',
      scrollTrigger: { trigger: section, start: 'top top', end: 'bottom bottom', scrub: 0.8 }
    });
  }
}

/* ══════════════════════════════════════════
   CRAFT REGIONS — Real India SVG map + GSAP image animations
   ══════════════════════════════════════════ */
function initCraftRegions() {
  var section = document.querySelector('.n-craft');
  var hoverImg = document.getElementById('n-craft-hover');
  var hoverImgEl = hoverImg ? hoverImg.querySelector('img') : null;
  var items = document.querySelectorAll('.n-craft__item');
  var mapWrap = document.getElementById('n-craft-map');
  if (!hoverImg || !items.length) return;

  var curtain = document.getElementById('n-craft-curtain');
  var imgWrapEl = hoverImg ? hoverImg.querySelector('.n-craft__img-wrap') : null;
  var currentRegion = null;
  var isAnimating = false;

  /* ── Load the real India SVG map ── */
  if (mapWrap && window.__ninaraMapUrl) {
    fetch(window.__ninaraMapUrl)
      .then(function(r) { return r.text(); })
      .then(function(svgText) {
        mapWrap.innerHTML = svgText;
        gsap.from(mapWrap, { opacity: 0, scale: 0.92, duration: 0.8, ease: 'power2.out',
          scrollTrigger: { trigger: mapWrap, start: 'top 85%', once: true }
        });
      });
  }

  function highlightState(stateName) {
    if (!mapWrap) return;
    mapWrap.querySelectorAll('.allPaths').forEach(function(p) {
      p.classList.toggle('is-active', p.getAttribute('data-state') === stateName);
    });
  }

  function clearMapHighlight() {
    if (!mapWrap) return;
    mapWrap.querySelectorAll('.allPaths.is-active').forEach(function(p) {
      p.classList.remove('is-active');
    });
  }

  /* ── Curtain reveal animation (same as product cards) ── */
  function showImage(imgSrc) {
    if (isAnimating) return;
    isAnimating = true;

    if (!currentRegion) {
      /* First hover — curtain drop reveal */
      hoverImgEl.src = imgSrc;
      gsap.set(hoverImg, { visibility: 'visible' });
      gsap.set(curtain, { yPercent: 0 });
      gsap.set(imgWrapEl, { scale: 1.2 });

      gsap.to(curtain, { yPercent: 100, duration: 0.8, ease: 'power3.inOut' });
      gsap.to(imgWrapEl, { scale: 1, duration: 1.2, ease: 'power2.out',
        onComplete: function() { isAnimating = false; }
      });
    } else {
      /* Switching cities — curtain covers, swap image, curtain reveals */
      gsap.to(curtain, { yPercent: 0, duration: 0.35, ease: 'power2.in',
        onComplete: function() {
          hoverImgEl.src = imgSrc;
          gsap.set(imgWrapEl, { scale: 1.2 });
          gsap.to(curtain, { yPercent: 100, duration: 0.6, ease: 'power3.inOut' });
          gsap.to(imgWrapEl, { scale: 1, duration: 1, ease: 'power2.out',
            onComplete: function() { isAnimating = false; }
          });
        }
      });
    }
  }

  function hideImage() {
    /* Curtain covers back up */
    gsap.to(curtain, { yPercent: 0, duration: 0.5, ease: 'power2.in',
      onComplete: function() {
        gsap.set(hoverImg, { visibility: 'hidden' });
        isAnimating = false;
      }
    });
  }

  function activateRegion(regionName, stateName, imgSrc) {
    if (regionName === currentRegion) return;

    highlightState(stateName);
    items.forEach(function(it) { it.classList.toggle('is-active', it.dataset.region === regionName); });

    if (imgSrc && hoverImgEl) {
      showImage(imgSrc);
    }

    currentRegion = regionName;
  }

  function deactivateAll() {
    clearMapHighlight();
    items.forEach(function(it) { it.classList.remove('is-active'); });
    hideImage();
    currentRegion = null;
  }

  /* City list hover events */
  items.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      activateRegion(item.dataset.region, item.dataset.state, item.dataset.image);
    });
  });

  /* Leave section — deactivate all */
  if (section) {
    section.addEventListener('mouseleave', deactivateAll);
  }

  /* Scroll-in animation for city items */
  items.forEach(function(item, i) {
    gsap.from(item, { opacity: 0, x: 20, duration: 0.5, delay: i * 0.1, scrollTrigger: { trigger: item, start: 'top 88%', once: true } });
  });
}

/* ══════════════════════════════════════════
   FOUNDER LETTER — CSS sticky + scrubbed panel split
   Section height: 250vh → sticky inner = 100vh → 150vh of scroll
   Panels open over first 60% of section (0-60% = 0-90vh scroll)
   Then hold revealed for remaining 40% (60vh) before natural unpin
   ══════════════════════════════════════════ */
function initFounderLetter() {
  var section = document.querySelector('.n-founder');
  if (!section) return;

  var leftPanel = section.querySelector('.n-founder__panel--left');
  var rightPanel = section.querySelector('.n-founder__panel--right');
  var topPanel = section.querySelector('.n-founder__panel--top');
  var bottomPanel = section.querySelector('.n-founder__panel--bottom');

  /* Desktop panels */
  if (leftPanel) {
    gsap.to(leftPanel, { xPercent: -100, ease: 'power2.inOut', scrollTrigger: { trigger: section, start: 'top top', end: '60% top', scrub: 1.5 } });
  }
  if (rightPanel) {
    gsap.to(rightPanel, { xPercent: 100, ease: 'power2.inOut', scrollTrigger: { trigger: section, start: 'top top', end: '60% top', scrub: 1.5 } });
  }

  /* Mobile panels */
  if (topPanel) {
    gsap.to(topPanel, { yPercent: -100, ease: 'power2.inOut', scrollTrigger: { trigger: section, start: 'top top', end: '60% top', scrub: 1.5 } });
  }
  if (bottomPanel) {
    gsap.to(bottomPanel, { yPercent: 100, ease: 'power2.inOut', scrollTrigger: { trigger: section, start: 'top top', end: '60% top', scrub: 1.5 } });
  }
}

/* ══════════════════════════════════════════
   GENERIC FADE-IN REVEALS
   ══════════════════════════════════════════ */
function initFadeIns() {
  document.querySelectorAll('[data-fade-in]').forEach(function(el) {
    var delay = parseFloat(el.dataset.fadeDelay || '0');
    var dir = el.dataset.fadeIn || 'up';
    var from = { opacity: 0 };
    if (dir === 'up') from.y = 30;
    else if (dir === 'left') from.x = -30;
    else if (dir === 'right') from.x = 30;
    from.duration = 0.8; from.delay = delay; from.ease = 'power3.out';
    from.scrollTrigger = { trigger: el, start: 'top 88%', once: true };
    gsap.from(el, from);
  });
}

/* ══════════════════════════════════════════
   WATCH & BUY
   ══════════════════════════════════════════ */
function initWatchAndBuy() {
  document.querySelectorAll('.n-watch__card').forEach(function(card, i) {
    gsap.from(card, { opacity: 0, x: 50, duration: 0.6, delay: i * 0.1, scrollTrigger: { trigger: card, start: 'top 88%', once: true } });
  });
}

/* ══════════════════════════════════════════
   WISHLIST — localStorage-based
   ══════════════════════════════════════════ */
function initWishlist() {
  var STORE_KEY = 'n-wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '[]'); } catch(e) { return []; }
  }

  function saveList(list) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(list)); } catch(e) {}
  }

  function isWishlisted(id) {
    return getList().some(function(p) { return String(p.id) === String(id); });
  }

  function updateCounter() {
    var count = getList().length;
    document.querySelectorAll('#n-wishlist-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-add]').forEach(function(btn) {
      var id = btn.dataset.productId;
      btn.classList.toggle('is-wishlisted', isWishlisted(id));
    });
  }

  function renderDrawer() {
    var list = getList();
    var body = document.getElementById('n-wishlist-body');
    if (!body) return;

    if (!list.length) {
      body.innerHTML = '<div class="n-cart-drawer__empty-icon"><svg width="48" height="48" stroke-width="1"><use href="#icon-heart"/></svg></div>' +
        '<p class="n-cart-drawer__empty-title">Your wishlist is empty</p>' +
        '<p class="n-cart-drawer__empty-text">Tap the heart on any piece to save it here.</p>';
      return;
    }

    var html = '<div class="n-wishlist-items">';
    list.forEach(function(p) {
      var price = (parseInt(p.price, 10) / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 });
      html += '<div class="n-wishlist-item">' +
        (p.image ? '<img src="' + p.image + '" alt="' + p.title + '" class="n-wishlist-item__img">' : '<div class="n-wishlist-item__img n-wishlist-item__img--empty"></div>') +
        '<div class="n-wishlist-item__info">' +
          '<a href="' + p.url + '" class="n-wishlist-item__title">' + p.title + '</a>' +
          '<span class="n-wishlist-item__price">' + price + '</span>' +
          '<div class="n-wishlist-item__actions">' +
            '<a href="' + p.url + '" class="n-wishlist-item__view">View</a>' +
            '<button class="n-wishlist-item__remove" data-remove-id="' + p.id + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    });
    html += '</div>';
    body.innerHTML = html;

    body.querySelectorAll('[data-remove-id]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = this.dataset.removeId;
        var l = getList().filter(function(p) { return String(p.id) !== String(id); });
        saveList(l);
        updateCounter();
        updateAllButtons();
        renderDrawer();
      });
    });
  }

  /* Toggle product in/out of wishlist */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-add]');
    if (!btn) return;
    var id = btn.dataset.productId;
    var list = getList();
    if (isWishlisted(id)) {
      saveList(list.filter(function(p) { return String(p.id) !== String(id); }));
    } else {
      list.unshift({
        id: id,
        title: btn.dataset.productTitle || '',
        price: btn.dataset.productPrice || '0',
        url: btn.dataset.productUrl || '#',
        image: btn.dataset.productImage || ''
      });
      saveList(list);
    }
    updateCounter();
    updateAllButtons();
    renderDrawer();
  });

  /* Wishlist drawer open/close */
  var overlay = document.querySelector('.n-cart-overlay');
  var drawer = document.getElementById('n-wishlist-drawer');

  function openWishlist() {
    renderDrawer();
    if (overlay) overlay.classList.add('is-open');
    if (drawer) drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeWishlist() {
    if (overlay) overlay.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-open-wishlist]').forEach(function(btn) {
    btn.addEventListener('click', openWishlist);
  });
  document.querySelectorAll('[data-close-wishlist]').forEach(function(btn) {
    btn.addEventListener('click', closeWishlist);
  });
  if (overlay) {
    overlay.addEventListener('click', function() {
      closeWishlist();
      /* also close cart if open */
      var cartDrawer = document.getElementById('n-cart-drawer');
      if (cartDrawer) cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  updateCounter();
  updateAllButtons();
}

/* ══════════════════════════════════════════
   RECENTLY VIEWED — renders on PDP
   ══════════════════════════════════════════ */
function initRecentlyViewed() {
  var section = document.getElementById('n-recently-viewed');
  var grid = document.getElementById('n-recently-viewed-grid');
  if (!section || !grid) return;

  var currentId = document.getElementById('n-pdp-product-id')?.dataset.id;
  var stored = [];
  try { stored = JSON.parse(localStorage.getItem('n-rv') || '[]'); } catch(e) {}
  var filtered = stored.filter(function(p) { return String(p.id) !== String(currentId); }).slice(0, 4);

  if (!filtered.length) return;

  filtered.forEach(function(p) {
    var card = document.createElement('div');
    card.innerHTML = '<a href="' + p.url + '" class="n-product-card">' +
      '<div class="n-product-card__img">' + (p.image ? '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">' : '') + '</div>' +
      '<div class="n-product-card__info"><div class="n-product-card__row">' +
      '<h3 class="n-product-card__name">' + p.title + '</h3>' +
      '</div></div></a>';
    grid.appendChild(card);
  });

  section.style.display = '';
}

/* ══════════════════════════════════════════
   SCROLL TO TOP
   ══════════════════════════════════════════ */
(function() {
  var btn = document.getElementById('n-scroll-top');
  if (!btn) return;
  window.addEventListener('scroll', function() {
    if (window.scrollY > 600) btn.classList.add('is-visible');
    else btn.classList.remove('is-visible');
  }, { passive: true });
  btn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

/* ══════════════════════════════════════════
   AJAX CART — ATC interception, drawer render, qty, remove
   Free shipping threshold read from data attr set in header.liquid
   ══════════════════════════════════════════ */
function initCartAjax() {
  var thresholdEl = document.getElementById('n-cart-free-threshold');
  var FREE_THRESHOLD = thresholdEl ? parseInt(thresholdEl.dataset.threshold, 10) : 199900;

  function fmtPrice(paise) {
    return (paise / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 });
  }

  function openCartDrawer() {
    var overlay = document.getElementById('n-cart-overlay');
    var drawer = document.getElementById('n-cart-drawer');
    if (overlay) overlay.classList.add('is-open');
    if (drawer) drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function renderCart(cart) {
    var body = document.getElementById('n-cart-drawer-body');
    var countEl = document.getElementById('n-cart-count');
    var badge = document.getElementById('n-cart-badge');
    if (countEl) countEl.textContent = cart.item_count;
    if (badge) badge.textContent = cart.item_count;
    if (!body) return;

    if (!cart.item_count) {
      body.className = 'n-cart-drawer__body';
      body.innerHTML =
        '<div class="n-cart-drawer__empty-icon"><svg width="48" height="48" stroke-width="1"><use href="#icon-bag"/></svg></div>' +
        '<p class="n-cart-drawer__empty-title">Your cart is empty</p>' +
        '<p class="n-cart-drawer__empty-text">Discover our latest collections and find something beautiful.</p>' +
        '<button class="n-cart-drawer__cta" data-close-cart><span class="n-cart-drawer__cta-fill"></span><span>Continue Shopping</span></button>';
      body.querySelector('[data-close-cart]')?.addEventListener('click', function() {
        var o = document.getElementById('n-cart-overlay');
        var d = document.getElementById('n-cart-drawer');
        if (o) o.classList.remove('is-open');
        if (d) d.classList.remove('is-open');
        document.body.style.overflow = '';
      });
      return;
    }

    body.className = 'n-cart-drawer-scroll';
    var progress = Math.min(100, Math.round(cart.total_price * 100 / FREE_THRESHOLD));
    var remaining = fmtPrice(Math.max(0, FREE_THRESHOLD - cart.total_price));
    var shippingHtml = cart.total_price >= FREE_THRESHOLD
      ? '<p class="n-cart-shipping-bar__msg n-cart-shipping-bar__msg--done">You\'ve unlocked free shipping!</p>'
      : '<p class="n-cart-shipping-bar__msg">Add <strong>' + remaining + '</strong> more for free shipping</p>';

    var html = '<div class="n-cart-shipping-bar">' + shippingHtml +
      '<div class="n-cart-shipping-bar__track"><div class="n-cart-shipping-bar__fill" style="width:' + progress + '%"></div></div></div>';

    html += '<div class="n-cart-items">';
    cart.items.forEach(function(item) {
      var imgHtml = item.image ? '<img src="' + item.image.replace(/\.jpg(\?.*)?$/, '_100x.jpg') + '" alt="' + escHtml(item.product_title) + '">' : '';
      var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="n-cart-item__variant">' + escHtml(item.variant_title) + '</span>' : '';
      html += '<div class="n-cart-item" data-item-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="n-cart-item__img">' + imgHtml + '</a>' +
        '<div class="n-cart-item__info">' +
          '<a href="' + item.url + '" class="n-cart-item__title">' + escHtml(item.product_title) + '</a>' +
          variantHtml +
          '<div class="n-cart-item__row">' +
            '<div class="n-cart-qty">' +
              '<button class="n-cart-qty__btn" data-qty-change="' + item.key + '" data-qty-val="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease">−</button>' +
              '<span class="n-cart-qty__val">' + item.quantity + '</span>' +
              '<button class="n-cart-qty__btn" data-qty-change="' + item.key + '" data-qty-val="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="n-cart-item__price">' + fmtPrice(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button class="n-cart-item__remove" data-qty-change="' + item.key + '" data-qty-val="0" aria-label="Remove item">' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>' +
        '</button>' +
      '</div>';
    });
    html += '</div>';

    html += '<div class="n-cart-drawer__footer">' +
      '<div class="n-cart-subtotal"><span>Subtotal</span><span class="n-cart-subtotal__price">' + fmtPrice(cart.total_price) + '</span></div>' +
      '<p class="n-cart-checkout-note">Taxes and shipping calculated at checkout</p>' +
      '<a href="/checkout" class="n-cart-checkout-btn"><span class="n-cart-checkout-btn__fill"></span><span>Proceed to Checkout</span></a>' +
      '<a href="/cart" class="n-cart-view-link">View full cart</a>' +
    '</div>';

    body.innerHTML = html;

    body.querySelectorAll('[data-qty-change]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = this.dataset.qtyChange;
        var qty = parseInt(this.dataset.qtyVal, 10);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function(r) { return r.json(); }).then(renderCart);
      });
    });
  }

  function escHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  window.nRenderCart = renderCart;

  /* Fetch and render cart on page load */
  fetch('/cart.js').then(function(r) { return r.json(); }).then(renderCart);

  /* Intercept ALL add-to-cart form submissions */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.matches('form[action="/cart/add"]')) return;
    e.preventDefault();
    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    var origText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js');
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCart(cart);
        openCartDrawer();
      })
      .catch(function() { form.submit(); })
      .finally(function() {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
      });
  }, true);

  /* Buy Now button on PDP */
  var buyNowBtn = document.getElementById('n-pdp-buy-now');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function() {
      var form = document.querySelector('form[action="/cart/add"]');
      if (!form) return;
      var formData = new FormData(form);
      buyNowBtn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function() { window.location.href = '/checkout'; })
        .catch(function() { buyNowBtn.disabled = false; });
    });
  }

  /* Lightbox for PDP images */
  (function() {
    var lb = document.getElementById('n-lightbox');
    if (!lb) return;
    var lbImg = lb.querySelector('.n-lightbox__img');
    var lbClose = lb.querySelector('.n-lightbox__close');
    var lbPrev = lb.querySelector('.n-lightbox__prev');
    var lbNext = lb.querySelector('.n-lightbox__next');
    var allImages = [];
    var lbIdx = 0;

    document.querySelectorAll('.n-pdp-img img').forEach(function(img, i) {
      allImages.push(img.src);
      img.parentElement.style.cursor = 'zoom-in';
      img.parentElement.addEventListener('click', function() {
        lbIdx = i;
        showLightbox(img.src);
      });
    });

    function showLightbox(src) {
      if (lbImg) { lbImg.style.opacity = '0'; lbImg.src = src; lbImg.onload = function() { lbImg.style.opacity = '1'; }; }
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    lb.addEventListener('click', function(e) { if (e.target === lb) closeLightbox(); });
    if (lbPrev) lbPrev.addEventListener('click', function() {
      lbIdx = (lbIdx - 1 + allImages.length) % allImages.length;
      showLightbox(allImages[lbIdx]);
    });
    if (lbNext) lbNext.addEventListener('click', function() {
      lbIdx = (lbIdx + 1) % allImages.length;
      showLightbox(allImages[lbIdx]);
    });
    document.addEventListener('keydown', function(e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft' && lbPrev) lbPrev.click();
      if (e.key === 'ArrowRight' && lbNext) lbNext.click();
    });
  })();

  /* PDP thumbnail strip */
  (function() {
    var thumbs = document.querySelectorAll('.n-pdp-thumb');
    if (!thumbs.length) return;
    var allImages = JSON.parse(document.getElementById('n-pdp-images-data')?.textContent || '[]');
    var imgSrcMap = {};
    allImages.forEach(function(img) { imgSrcMap[img.id] = img.src; });
    var gallery = document.getElementById('n-pdp-gallery');
    var slides = gallery ? gallery.querySelectorAll('.n-pdp-img') : [];

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var src = thumb.dataset.imageSrc;
        if (!src) return;
        if (window.innerWidth >= 768) {
          /* Desktop: replace first gallery slot */
          var firstImg = slides[0] ? slides[0].querySelector('img') : null;
          if (firstImg) {
            firstImg.style.transition = 'opacity 0.3s';
            firstImg.style.opacity = '0';
            setTimeout(function() { firstImg.src = src; firstImg.style.opacity = '1'; }, 200);
          }
        } else {
          /* Mobile: scroll to slide */
          if (slides[i]) slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });
  })();

  /* Quick View */
  (function() {
    var qvOverlay = document.getElementById('n-qv-overlay');
    var qvModal = document.getElementById('n-qv-modal');
    var qvClose = document.getElementById('n-qv-close');
    var qvBody = document.getElementById('n-qv-body');
    if (!qvOverlay || !qvModal) return;

    function closeQV() {
      qvOverlay.classList.remove('is-open');
      qvModal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    function openQV() {
      qvOverlay.classList.add('is-open');
      qvModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    if (qvClose) qvClose.addEventListener('click', closeQV);
    qvOverlay.addEventListener('click', closeQV);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeQV(); });

    document.querySelectorAll('[data-qv-handle]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var handle = this.dataset.qvHandle;
        if (qvBody) qvBody.innerHTML = '<div style="padding:3rem;text-align:center;color:var(--color-secondary);font-size:0.875rem">Loading…</div>';
        openQV();
        fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(product) {
            var firstImg = product.images && product.images.length ? product.images[0] : '';
            var price = fmtPrice(product.price_min);
            var variantsHtml = '';
            
            var nColorMap = {
              'black': '#1a1a1a', 'maroon': '#800000', 'red': '#ff0000',
              'ivory': '#fffff0', 'gold': '#ffd700', 'deep-red': '#8b0000',
              'olive': '#808000', 'terracotta': '#b05c35', 'white': '#ffffff'
            };

            if (product.variants.length > 1) {
              product.options.forEach(function(option, oi) {
                var optionName = (option && typeof option === 'object') ? (option.name || '') : option;
                var isColor = optionName.toLowerCase() === 'color' || optionName.toLowerCase() === 'colour';
                var vals = product.variants.map(function(v) { return v['option' + (oi + 1)]; }).filter(function(v, i, a) { return a.indexOf(v) === i; });
                
                variantsHtml += '<label class="n-qv-option-label">' + escHtml(optionName) + '</label><div class="' + (isColor ? 'n-qv-color-swatches' : 'n-qv-pills') + '" data-qv-option="' + oi + '">';
                vals.forEach(function(val, vi) {
                  if (isColor) {
                    var handleize = val.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
                    var bg = nColorMap[handleize] || handleize;
                    variantsHtml += '<button type="button" class="n-qv-color-swatch' + (vi === 0 ? ' is-selected' : '') + '" data-val="' + escHtml(val) + '" title="' + escHtml(val) + '"><span class="n-qv-color-swatch__circle" style="background:' + bg + '"></span></button>';
                  } else {
                    variantsHtml += '<button type="button" class="n-qv-pill' + (vi === 0 ? ' is-selected' : '') + '" data-val="' + escHtml(val) + '">' + escHtml(val) + '</button>';
                  }
                });
                variantsHtml += '</div>';
              });
            }
            var avail = product.available;
            var allImgs = product.images || [];
            var thumbsHtml = '';
            if (allImgs.length > 1) {
              thumbsHtml = '<div class="n-qv-thumbs">';
              allImgs.forEach(function(img, ti) {
                thumbsHtml += '<div class="n-qv-thumb' + (ti === 0 ? ' is-active' : '') + '" data-src="' + escHtml(img) + '">' +
                  '<img src="' + escHtml(img) + '" alt="" loading="lazy"></div>';
              });
              thumbsHtml += '</div>';
            }
            if (qvBody) qvBody.innerHTML =
              '<div class="n-qv-img-col"><div class="n-qv-img-main"><img id="n-qv-main-img" src="' + escHtml(firstImg) + '" alt="' + escHtml(product.title) + '" loading="lazy"></div>' + thumbsHtml + '</div>' +
              '<div class="n-qv-info-col">' +
                '<h3>' + escHtml(product.title) + '</h3>' +
                '<p class="n-qv-price">' + price + '</p>' +
                variantsHtml +
                '<input type="hidden" id="n-qv-variant-id" value="' + product.variants[0].id + '">' +
                '<button type="button" class="n-qv-atc"' + (!avail ? ' disabled' : '') + '>' + (avail ? 'Add to Cart' : 'Sold Out') + '</button>' +
                '<a href="' + product.url + '" class="n-qv-view-link">View full product →</a>' +
              '</div>';

            /* Variant selection in QV */
            var qvSelections = {};
            product.options.forEach(function(_, i) { qvSelections[i] = product.variants[0]['option' + (i + 1)]; });
            qvBody.querySelectorAll('[data-qv-option]').forEach(function(group) {
              group.querySelectorAll('button').forEach(function(pill) {
                pill.addEventListener('click', function() {
                  var oi = parseInt(group.dataset.qvOption, 10);
                  qvSelections[oi] = pill.dataset.val;
                  group.querySelectorAll('button').forEach(function(p) { p.classList.remove('is-selected'); });
                  pill.classList.add('is-selected');
                  var matched = product.variants.find(function(v) {
                    return product.options.every(function(_, i) { return v['option' + (i + 1)] === qvSelections[i]; });
                  });
                  var vidInput = qvBody.querySelector('#n-qv-variant-id');
                  var atcBtn = qvBody.querySelector('.n-qv-atc');
                  if (matched && vidInput) { vidInput.value = matched.id; }
                  if (atcBtn && matched) { atcBtn.disabled = !matched.available; atcBtn.textContent = matched.available ? 'Add to Cart' : 'Sold Out'; }
                });
              });
            });

            /* QV Thumbnail strip */
            qvBody.querySelectorAll('.n-qv-thumb').forEach(function(thumb) {
              thumb.addEventListener('click', function() {
                var src = thumb.dataset.src;
                var mainImg = qvBody.querySelector('#n-qv-main-img');
                if (mainImg && src) {
                  mainImg.style.opacity = '0';
                  setTimeout(function() { mainImg.src = src; mainImg.style.opacity = '1'; }, 250);
                }
                qvBody.querySelectorAll('.n-qv-thumb').forEach(function(t) { t.classList.remove('is-active'); });
                thumb.classList.add('is-active');
              });
            });

            /* QV ATC */
            var qvAtc = qvBody.querySelector('.n-qv-atc');
            if (qvAtc) {
              qvAtc.addEventListener('click', function() {
                var vid = qvBody.querySelector('#n-qv-variant-id')?.value;
                if (!vid) return;
                qvAtc.disabled = true; qvAtc.textContent = 'Adding…';
                var fd = new FormData();
                fd.append('id', vid); fd.append('quantity', '1');
                fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                  .then(function() { return fetch('/cart.js'); })
                  .then(function(r) { return r.json(); })
                  .then(function(cart) {
                    renderCart(cart);
                    closeQV();
                    openCartDrawer();
                  })
                  .catch(function() { qvAtc.disabled = false; qvAtc.textContent = 'Add to Cart'; });
              });
            }
          });
      });
    });
  })();
}

/* ══════════════════════════════════════════
   NEWSLETTER FORM — AJAX submit + inline success
   ══════════════════════════════════════════ */
function initNewsletterForm() {
  var form = document.querySelector('.n-footer__form');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var emailInput = form.querySelector('[type="email"]');
    if (!emailInput || !emailInput.value.trim()) return;
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.textContent = '…';
    var params = new URLSearchParams();
    params.append('form_type', 'customer');
    params.append('utf8', '✓');
    params.append('contact[email]', emailInput.value.trim());
    params.append('contact[tags]', 'newsletter');
    fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: params.toString()
    })
    .then(function() {
      form.innerHTML = '<p class="n-footer-newsletter__success">Thank you for subscribing!</p>';
    })
    .catch(function() {
      if (btn) { btn.disabled = false; btn.textContent = 'Subscribe'; }
    });
  });
}

/* ══════════════════════════════════════════
   ENQUIRY FORMS — AJAX submit + inline success (MTM + LSS)
   ══════════════════════════════════════════ */
function initEnquiryForms() {
  ['n-mtm-form', 'n-lss-form'].forEach(function(cls) {
    var form = document.querySelector('.' + cls);
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
      fetch('/contact', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function() {
        var successDiv = document.createElement('div');
        successDiv.className = 'n-form-success';
        successDiv.innerHTML = '<h3>Thank you!</h3><p>Your enquiry has been received. We\'ll be in touch within 48 hours.</p>';
        form.parentNode.insertBefore(successDiv, form);
        form.style.display = 'none';
      })
      .catch(function() {
        if (btn) { btn.disabled = false; btn.textContent = 'Send Enquiry'; }
      });
    });
  });
}

/* ══════════════════════════════════════════
   VIDEO LIGHTBOX — Watch & Buy cards
   ══════════════════════════════════════════ */
function initVideoLightbox() {
  var lb = document.getElementById('n-vid-lb');
  if (!lb) return;
  var inner = document.getElementById('n-vid-lb-inner');
  var closeBtn = document.getElementById('n-vid-lb-close');

  function openVideo(url) {
    if (!url || !inner) return;
    var embedUrl = url;
    var ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]+)/);
    if (ytMatch) embedUrl = 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0';
    var vimMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimMatch) embedUrl = 'https://player.vimeo.com/video/' + vimMatch[1] + '?autoplay=1';
    var isNativeVideo = /\.(mp4|webm|ogg)(\?|$)/i.test(url);
    if (isNativeVideo) {
      inner.innerHTML = '<video src="' + url + '" controls autoplay playsinline></video>';
    } else {
      inner.innerHTML = '<iframe src="' + embedUrl + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    }
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeVideo() {
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function() { if (inner) inner.innerHTML = ''; }, 300);
  }

  if (closeBtn) closeBtn.addEventListener('click', closeVideo);
  lb.addEventListener('click', function(e) { if (e.target === lb) closeVideo(); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && lb.classList.contains('is-open')) closeVideo();
  });

  document.querySelectorAll('.n-watch__card[data-video]').forEach(function(card) {
    var url = card.dataset.video;
    if (!url) return;
    card.addEventListener('click', function() { openVideo(url); });
  });
}
